import {
  Text,
  ExpandableText,
  buildOptionTestId,
} from "@simplybusiness/mobius";
import type {
  TradeOption,
  TradeSelectionMeta,
} from "@simplybusiness/mobius-trade-selector";
import { TradesPrompt } from "./TradesPrompt";

export const TradesListState = ({
  trades,
  searchId,
  variant,
  onTradeSelect,
}: {
  trades: TradeOption[];
  searchId?: string;
  variant: "default" | "ai";
  onTradeSelect: (trade: TradeOption, meta: TradeSelectionMeta) => void;
}) => {
  return (
    <div>
      <TradesPrompt />
      {trades.map((trade: TradeOption, index: number) => {
        const testId = buildOptionTestId("trade-option", trade.value);
        return (
          <button
            key={trade.value}
            type="button"
            data-testid={testId}
            onClick={() => onTradeSelect(trade, { index, searchId, variant })}
            className="mobius-ai-trade-question__trade-item"
          >
            <Text className="mobius-ai-trade-question__trade-title">
              {trade.value}
            </Text>
            {trade.definition && (
              <ExpandableText
                text={trade.definition}
                maxLines={3}
                breakpoint="sm"
                showText="Read more"
                hideText="Read less"
                className="mobius-ai-trade-question__trade-definition"
                textProps={{ elementType: "span" }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
};
